import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="roleta-collapsible"
export default class extends Controller {
  static targets = ['content', 'chevron', 'buttonText']

  connect() {
    // Initialize as collapsed
    this.isExpanded = false
    this.updateState()
  }

  toggle() {
    this.isExpanded = !this.isExpanded
    this.updateState()
  }

  updateState() {
    if (this.hasContentTarget) {
      if (this.isExpanded) {
        // Expand
        this.contentTarget.style.maxHeight = this.contentTarget.scrollHeight + 'px'
        this.contentTarget.classList.remove('max-h-0')
      } else {
        // Collapse
        this.contentTarget.style.maxHeight = '0'
        this.contentTarget.classList.add('max-h-0')
      }
    }

    // Rotate chevron
    if (this.hasChevronTarget) {
      if (this.isExpanded) {
        this.chevronTarget.style.transform = 'rotate(180deg)'
      } else {
        this.chevronTarget.style.transform = 'rotate(0deg)'
      }
    }

    // Update button text
    if (this.hasButtonTextTarget) {
      if (this.isExpanded) {
        this.buttonTextTarget.textContent = 'Clique para minimizar'
      } else {
        this.buttonTextTarget.textContent = 'Clique para expandir'
      }
    }
  }
}
